import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Translate, getTranslate, getActiveLanguage } from "react-localize-redux"
import PropTypes from "prop-types"
import LazyLoad from "react-lazyload"
import { showIFrameModal } from "../../redux/modules/Modal"
import { FooterMenuLinks } from "../../configs/MenuLinks"
import SBTextLogo from "../../images/logos/sb-text-logo.svg"

class Footer extends React.Component {
	renderMenuGroup = ({ title, titlePath, items }, locale, index) => {
		return (
			<div className="col-lg-3 col-md-6 mb-3 mb-lg-0" key={index}>
				<div className="group-heading">
					<a href={titlePath}>{title}</a>
				</div>
				<ul className="footer-menu">
					{items.map((value, subIndex) =>
						this.renderMenuItems(value, locale, subIndex)
					)}
				</ul>
			</div>
		)
	}

	renderMenuItems = ({ path, title, className }, locale, subIndex) => {
		return (
			<li key={subIndex}>
				<a href={path}>{title}</a>
			</li>
		)
	}

	render() {
		const currentUrl = this.props.location.pathname
		const { currentLanguage } = this.props
		const iFrame_url =
			"//consent-pref.trustarc.com/?type=starbucks&site=starbucks.com&action=notice&country=kh&locale=en&behavior=implied&layout=default_eu&from=http://consent.trustarc.com/"
		return (
			<Translate>
				{(translate, activeLanguage, languages) => {
					const locale = activeLanguage.code
					return (
						<footer id="footer" className="container-fluid">
							{currentLanguage === "en" && (
								<div className="row">
									{FooterMenuLinks.map((value, index) =>
										this.renderMenuGroup(value, locale, index)
									)}
								</div>
							)}
							{currentLanguage === "km" && (
								<div className="row">
									{FooterMenuLinks.map((value, index) =>
										this.renderMenuGroup(value, locale, index)
									)}
								</div>
							)}
							<div className="region mt-4">
								<b>
									<Translate id="footer.footerMenu._Change_Region" /> »
								</b>
								<span className="footer-link">
									{languages.map(
										(language) =>
											language.active ? (
												<span
													key={language.code}
													className="mx-2">
													<Translate
														id={`footer.footerMenu._${
															language.name
														}`}
													/>
												</span>
											) : (
												<span key={language.code}>
													<a
														href={
															currentUrl &&
															!!currentUrl.length &&
															currentUrl.includes(
																activeLanguage.code
															)
																? currentUrl.replace(
																		`/${
																			activeLanguage.code
																		}/`,
																		`/${
																			language.code
																		}/`
																  )
																: `/${language.code}/`
														}
														className="link link-underline fw6 mx-1 fw-bold color-text-1">
														<Translate
															id={`footer.footerMenu._${
																language.name
															}`}
														/>
													</a>
													<span>»</span>
												</span>
											)
									)}
								</span>
							</div>
							{currentLanguage && (
								<div className="footer-links mt-2">
									<span className="footer-link">
										<a href="http://www.starbucks.com.kh/about-us/company-information/online-policies/web-accessibility">
											Web Accessibility
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.com.kh/about-us/company-information/online-policies/privacy-statement">
											Privacy Statement
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.com.kh/about-us/company-information/online-policies/terms-of-use">
											Terms of Use
										</a>
									</span>
									<span className="footer-link">
										<a href="http://www.starbucks.com.kh/site-map">
											Site Map
										</a>
									</span>
									<span className="footer-link">
										<span
											className="link"
											onClick={() =>
												this.props.showIFrameModal(
													iFrame_url,
													"300px",
													"100%"
												)
											}>
											Cookie Preferences
										</span>
									</span>
								</div>
							)}

							<div className="copyright row mt-2 align-items-center">
								<div className="col-sm-8">
									{<Translate id="footer._copyright" />}
								</div>
								<div className="col-sm-4 footer-logo text-left text-sm-right mt-sm-0 mt-2">
									<LazyLoad height={60}>
										<img src={SBTextLogo} alt="Starbucks logo" />
									</LazyLoad>
								</div>
							</div>
						</footer>
					)
				}}
			</Translate>
		)
	}
}

Footer.propTypes = {
	location: PropTypes.object.isRequired,
	currentLanguage: PropTypes.string.isRequired,
}

const mapStateToProps = ({ locale }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
})
const mapDispatchToProps = (dispatch) => ({
	showIFrameModal: bindActionCreators(showIFrameModal, dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/views/layout/Footer.js